import { Box, ButtonBase, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./AboutMe.styles";
import { skills, stacks } from "./constants";
import coder from "../../../../assets/images/coder.png";
import StackCard from "../../../../components/StackCard";

type stackTypes = {
  id: number;
  description: string;
  title: string;
  icon: string;
};

function AboutMe() {
  const classes = useStyles();

  return (
    <Grid className={classes.aboutComp}>
      <Grid container spacing={3}>
        <Grid item sm={12} md={6} className={classes.coderImgWrap}>
          <img src={coder} alt="" className={classes.svgIcon} />
        </Grid>
        <Grid item sm={12} md={6}>
          <Typography className={classes.aboutTitle}>About me</Typography>

          <p className={classes.shortNote}>
            Hi, I'm <b>Promise Stephen,</b> a passionate and dynamic Fullstack
            Developer with a strong focus on front-end technologies. With a
            background in software engineering and years of hands-on experience,
            I specialize in creating scalable, high-performance applications
            that provide exceptional user experiences. Over the years, I’ve
            worked with innovative teams and startups, contributing to the
            development of robust web applications, integrating APIs, and
            optimizing cloud-based infrastructures. My toolkit includes
            cutting-edge technologies like React, Redux, TypeScript, and
            Next.js, and I thrive in Agile environments where collaboration and
            creativity fuel progress. Beyond coding, I enjoy mentoring upcoming
            developers, sharing knowledge, and learning from the ever-evolving
            tech landscape. I am committed to building impactful digital
            solutions that make a difference in people’s lives. When I’m not
            coding, you’ll find me exploring new tech trends or brainstorming
            ideas for the next big project.
          </p>

          <Box className={classes.skillWrapper}>
            {skills.map((skill: string, i) => (
              <ButtonBase key={i} className={classes.skillName}>
                {skill}
              </ButtonBase>
            ))}
          </Box>
        </Grid>
      </Grid>
      <p>
        <Typography className={classes.DoTitle}>What I Do</Typography>
        <Grid container spacing={5}>
          {stacks.map((item: stackTypes) => (
            <Grid item md={4} sm={6} xs={12}>
              <StackCard
                key={item.id}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            </Grid>
          ))}
        </Grid>
      </p>
    </Grid>
  );
}

export default AboutMe;
